<template>
    <div :style = "hover ? 'background-color: #f0f0f0' : ''">
        <div class="v-flex lm-border pa-1 pl-2 status-row">
            <div
                v-for  = "(data, index) in incident.data"
                :key   = "index"
                class  = "unit-header-step"
                :class ="unitStepStatus(data, index)"
            >
                {{ data.sequence }}
            </div>

            <c-clipboard-chip
                v-if="clipboardUnit(incident.data[0], unit)"
                size="small"
            />
        </div>

        <p-inc-navigation-unit
            :site  = "unit"
            style  = "width: 300px;"
            :class = "background"
            :style = "hover ? 'background-color: #f0f0f0' : ''"
            @remove = "onRemove"
        />
    </div>
</template>

<script>

import CClipboardChip from "@/modules/inc/steps/components/common/clipboard/CClipboardChip.vue";
import PIncNavigationUnit from "@/modules/inc/steps/components/navigation/private/PIncNavigationUnit.vue";
import Inc from "@/modules/inc/service/Inc";

export default {
    name: "PIncNavigationEntry",

    components: {
        PIncNavigationUnit,
        CClipboardChip
    },

    props: {
        incident: {

        },

        unit: {

        },

        hover: {

        },
    },

    computed: {
        selected () {
            return this.$store.getters.context.site;
        },

        background () {
            return this.selected === this.unit.id ? 'primary-border-thick ' : '';
        },

        /*
        background () {
            return this.selected ? "background-selected" : "";
        },

         */
    },

    methods: {
        onRemove () {
            this.$emit("remove", this.unit)
        },

        clipboardUnit (data, unit) {
            const entry = data.collection.find(e => e.unit.id === unit.id);
            if (!entry) {
                return false;
            }

            return entry.clipboardEntry;
        },

        unitStepStatus (data, index) {
            const entry = data.collection.find (e => e.unit.id === this.unit.id);
            if (!entry) {
                return null;
            }

            if (index === 0) {
                return entry.valid ? "success" : "error";
            }

            switch (data.clazz) {
                case "StepDataRepairDto": {
                    const current = this.incident.data[index-2].collection.find(d => d.unit.id === this.unit.id);
                    if (!Inc.status.terminatedWithRepair.includes (current.status.id)) {
                        return null;
                    }
                    }
                    break;
                case "StepDataInvoiceCollectionDto": {
                    if (!data.visible) {
                        return null;
                    }
                    return entry.valid ? "success" : "error";
                }
                case "StepDataInvoiceDto":
                    console.log("invoice", data.clazz, this.unit.fabricNo, index)
                    break;
            }

            return entry.valid ? "success" : "error";
        },
    }
}
</script>

<style scoped>

.status-row {
    border-bottom:none!important;
    border-bottom-right-radius: 0!important;
    border-bottom-left-radius: 0!important;
}

.unit-header-step {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-color: lightgray;
    font-size: 14px;
    text-align: center;
    padding-top: 3px;
    margin-right: 4px;
    color: white;
}


</style>